const messages = {
  actions: 'Actions',
  assignRetailerAccount: 'Assign Retailer Account',
  assignHub: 'Assign Hub',
  cancelReplaceStyle: 'Cancel / Replace Style',
  cancelStyle: 'Cancel Style',
  changeSalesRep: 'Change Sales Rep',
  changeStatus: 'Change Status',
  connectionPendingTooltip:
    'Connection is being created. Retailer details will update once the connection is complete.',
  copyOrders: 'Copy Orders',
  duplicateOrders: 'Duplicate Orders',
  orderIsCreatedByRetailer: 'Created by Retailer',
  downloadOrderConfirmation: 'Download Order Confirmation',
  divisionCodeFilter:
    "What's New: Division Codes have been added back into Orders and you can filter by them now.",
  editEvent: 'Edit Event',
  errorMessage: (erroredCount) => (
    <span>
      <var>{erroredCount}</var> order(s) failed to update.
    </span>
  ),
  importOrders: 'Import Orders',
  exportData: 'Export Data',
  exportOrders: 'Export Orders',
  header: 'Manage Orders',
  markAsExported: 'Mark as Exported',
  new: 'New',
  createdByRetailerTooltipBody: (formattedCreatedAt) => (
    <span>
      Created by Retailer (<var>{formattedCreatedAt}</var>).
    </span>
  ),
  ordersApproved: 'Approved',
  ordersNotes: 'Notes',
  ordersWithQuantitiesTitle: 'Quantities',
  ordersWithQuantities: 'With',
  ordersWithoutQuantities: 'Without',
  ordersPending: 'Pending',
  ordersShipped: 'Shipped',
  ordersCancelled: 'Cancelled',
  ordersDraft: 'Draft',
  mergeOrders: 'Move Products',
  partialErrorMessage: (erroredCount, totalCount) => (
    <span>
      <var>{erroredCount}</var> of <var>{totalCount}</var> order(s) failed to
      update.
    </span>
  ),
  reExport: 'Set to Re-Export',
  removeStyleColors: 'Remove Style Colors With No Quantities',
  resendEmails: 'Resend Emails',
  scheduleExport: 'Schedule for Export',
  selectedOrders: (selectedLength, totalCount) =>
    selectedLength === 0 ? (
      <span>
        <var>{totalCount}</var>
        <span> total</span>
      </span>
    ) : (
      <span>
        <var>{selectedLength}</var>
        <span> selected out of </span>
        <var>{totalCount}</var>
        <span> total</span>
      </span>
    ),
  startOrder: 'Start an Order',
  successMessage: (successfulCount) => (
    <span>
      <var>{successfulCount}</var> order(s) have been updated.
    </span>
  ),
  unassignedOrdersTooltip:
    'This order needs to be assigned to a retailer account. Some actions may be disabled until it has been assigned.',
  updatePricing: 'Update Order Pricing',
  waitForExport:
    'Please remain on this page for your order to export. This can take up to a few minutes.',
  sendInvoice: 'Send Payment Link(s)',
  sendToAssortment: 'Send to Assortment',
}

export default messages
